<div class="home">
    <div class="head">
        <h1>Home</h1>
    </div>
    <div class="body">
        <h2>Generate Your Code</h2>
        <p><span>0</span> <span>0</span> <span>0</span> <span>0</span></p>
    </div>
</div>